const request = {}

request.createRequest = function (params) {
  return {
    orderList: params.orderList,
    paymentDate: params.date,
    paymentMethodId: params.method.value,
    completeDate: params.completeDate
  }
}
export default { request }
